// extracted by mini-css-extract-plugin
export default {"desc":"DescriptionItem_desc__44Ql1","item":"DescriptionItem_item__0MRzy","pressed":"DescriptionItem_pressed__xcLwY"};